import { Navigate, Outlet } from 'react-router-dom';
import { isLogin } from '../../utils/common';

export default function PublicRoute() {
  return isLogin ? <Navigate to="/" /> : <Outlet />;
}
